/* unplugin-vue-components disabled */import { render } from "./MemberView.vue?vue&type=template&id=89c5016a&scoped=true&lang=true"
import script from "./MemberView.vue?vue&type=script&lang=js"
export * from "./MemberView.vue?vue&type=script&lang=js"

import "./MemberView.vue?vue&type=style&index=0&id=89c5016a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c5016a"]])

export default __exports__